import { Model } from 'dva'
import { Language } from './types'
import { LanguagesService } from '../../Service'
import { IsObject } from '../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const Languages: Model = {
  namespace: 'languages',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let languages = yield select((state: any) => state.languages.list)
        if (!(languages.length > 0 && useCache)) {
          languages = yield call(LanguagesService.languagesList, {})
          yield put({ type: 'modifyList', payload: languages })
        }
        onSuccess(languages)
      } catch (err: any) {
        FailureHandler('Error fetching languages', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let language = yield select((state: any) =>
          state.languages.list.find((language: Language) => language.id === id)
        )
        if (!language) {
          language = yield call(LanguagesService.languagesRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: language })
        onSuccess(language)
      } catch (err) {
        FailureHandler('Could not find the language!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(LanguagesService.languagesCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a language', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(LanguagesService.languagesPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a language', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(LanguagesService.languagesDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a language', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Language) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Language) => !action.payload.map((p: Language) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Language) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetLanguages(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Languages
